import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Label } from '@bingads-webui-react/primitive';

/**
 * Higher-order component to wrap an form label with a CSS style to indicate it is required.
 * @param {Component} WrappedComponent - Form component to wrap.
 * @returns {Component} Form component with support for "required" styling.
 */
const withRequiredStyle = (WrappedComponent) => {
  const HOC = (props) => {
    const {
      classes,
      isRequired,
    } = props;

    const wrappedProps = _.omit(props, 'classes', 'isRequired');

    return (
      <WrappedComponent
        className={classNames({ [classes.required]: isRequired })}
        {...wrappedProps}
      />
    );
  };

  HOC.propTypes = {
    classes: PropTypes.shape({ required: PropTypes.string }).isRequired,
    isRequired: PropTypes.bool,
  };

  HOC.defaultProps = {
    isRequired: false,
  };

  HOC.displayName = `withRequiredStyle(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(HOC, WrappedComponent);
  return HOC;
};

export const LabelWithRequiredStyle = withDefaultStyles(withRequiredStyle(Label), () => ({
  required: {
    '&:after': {
      content: '" *"',
      color: '#a4262c',
    },
  },
}));

